import React from "react";
import { months } from "../../../../../../Utils/months";
import { DatosEditablesLatex, TotalRowNames } from "../Data/LatexData";
import LatexMonth from "./LatexMonth";
import { RowNames } from "../../../Utils/TableComponents";

export default function LatexTable() {
    const editableRowNames = Object.values(DatosEditablesLatex).map(item => item.rowName);

    const rowNames = [...editableRowNames, ...TotalRowNames];

    return (
        <div className="report__table-container">
            <h6>LÁTEX</h6>
            <div className="report__month-tables">
                <RowNames rowNames={rowNames} totalRows={[6, 8]} />
                {months.map((month, index) => {
                    return (<LatexMonth key={index} month={month} monthIndex={index} />)
                })}
            </div>
        </div>
    );
}
